<template>
  <div
    ref="parent"
    class="form-group">
    <label>{{ label }}</label>
    <textarea
      :rows="rows"
      :cols="cols"
      v-bind:class="{lowercase: lowercase}"
      ref="textarea"
      :disabled="disabled"
      :type="type"
      :error="error"
      :placeholder="placeholder"
      :value="value"
      :step="step"
      v-on="listeners">
    </textarea>
    <div
      :class="error ? 'error-message' : 'hidden'">
      <font-awesome-icon
        :icon="infoCircle"/>
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    step: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Error'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lowercase: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 5
    },
    cols: {
      type: Number,
      default: 40
    }
  },
  computed: {
    listeners () {
      return {
        input: event => this.$emit('input', event.target.value),
        click: event => this.$emit('click', event)
      };
    },
    infoCircle () {
      return faInfoCircle;
    }
  },
  methods: {
    focus () {
      this.$refs.textarea.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

$form-minw: $sp * 50;

.form-group {
  display: block;
  margin-bottom: $sp-margin-large;
  label {
    display: block;
    color: $black-trans4;

    .form--inverse & {
      color: $white-trans4;
    }
  }
  textarea {
    background-color: $white;
    border: 1px solid $black-trans6;
    border-radius: $radius;
    padding-left: $sp-margin-small;
    padding-right: $sp-margin-small;
    //height: 5 $height1;
    //TODO: HOW TO OVERRIDE THIS SETTING?
    //min-width: $form-minw;
    width: 100%;
    caret-color: $active;
    &:disabled {
      background: $disabled;
    }
    &::placeholder {
      color: $black-trans6;
    }
    &:hover {
      border-color: $black-trans4;
    }
    &:focus,
    &:active {
      outline: 0;
      border-color: $active;
    }

    .form--inverse & {
      background-color: transparent;
      border-color: $white-trans6;
      color: $white;
      &::placeholder {
        color: $white-trans6;
      }
      &:hover {
        border-color: $white-trans4;
      }
      &:focus,
      &:active {
        border-color: $active;
      }
    }
    resize: none;
    &[error="true"] {
      border-color: $error;
    }
  }
  .error-message {
    color: $error;
  }
  .hidden {
    visibility: hidden;
  }
}

.lowercase {
  text-transform: lowercase;
}

@mixin form-size($font-size, $height) {
  .form-group,
  &.form-group {
    font-size: $font-size;
  }
}
[form-size="xs"] {
  @include form-size($fs-xs, $height1);
}
[form-size="s"] {
  @include form-size($fs-s, $height2);
}
[form-size="m"] {
  @include form-size($fs, $height3);
}
[form-size="l"] {
  @include form-size($fs-xl, $height5);
}

</style>



// WEBPACK FOOTER //
// src/components/shared/forms/LabelTextarea.vue